<template>
  <div>
    <c-row>
      <loader v-show="loading" />
      <c-col col="8">
        <c-card>
          <c-card-body>
            <c-row class="one-row-form">
              <div class="col-md-6">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        v-bind:class="{ 'has-error': errors.faktur }"
                        >ID</span
                      >
                    </div>
                    <span
                      class="form-control"
                      v-bind:class="{ 'has-error': errors.faktur }"
                    >
                      {{ header.faktur }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        v-bind:class="{ 'has-error': errors.created_at }"
                      >
                        <i class="cil-calendar"></i>
                      </span>
                    </div>
                    <span
                      class="form-control"
                      v-bind:class="{ 'has-error': errors.created_at }"
                      >{{ header.created_at | formatDate }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select-x
                    url="/api/v1/customer"
                    :size="5"
                    placeholder="Silahkan pilih customer"
                    label="label"
                    v-model="header.customer"
                    @input="changeCustomer"
                    v-bind:class="{ 'has-error': errors.customer }"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <button class="btn btn-success" @click="custModal.show = true">
                  Tambah Pelanggan Baru
                </button>
              </div>
            </c-row>
          </c-card-body>
        </c-card>
        <c-card>
          <c-card-body v-bind:class="{ 'has-error': errors.sale_details }">
            <div class="form-group form-row">
              <div class="input-group col-md-3">
                <input
                  type="text"
                  ref="barcode"
                  class="form-control"
                  placeholder="barcode"
                  @keyup="searchItem"
                  v-model="barcode"
                />
                <div class="input-group-prepend">
                  <span class="input-group-text" @click="searchBox.show = true">
                    <i class="cil-barcode"></i>
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <product-selector
                  ref="items"
                  :query="$route.query"
                  v-model="item"
                  @input="changeProduct"
                />
              </div>
              <div class="col-md-2">
                <span class="form-control right" v-if="!item">0</span>
                <button-edit-input-2
                  @input="changePrice"
                  :bordered="true"
                  :rounded="true"
                  v-model="item.price"
                  v-if="item"
                />
              </div>
              <div class="col-md-1">
                <button class="btn btn-success" @click="addItem">
                  <i class="cil-plus"></i>
                </button>
              </div>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr bgcolor="#efefef">
                  <th width="30px">No</th>
                  <th width="100px">Code</th>
                  <th>Nama</th>
                  <th width="130px">Sub Total (Rp)</th>
                  <th width="30px">Act</th>
                  <th width="30px">
                    <i class="cil-print"></i>
                  </th>
                </tr>
              </thead>
              <tbody v-if="header">
                <tr v-for="(d, k) in header.details" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td class="unicode">
                    <span v-if="d.warranty">{{ d.warranty.warranty }}</span>
                  </td>
                  <td>
                    <span v-if="d.item">{{ d.item.name }}</span>
                  </td>
                  <td class="right">
                    <span
                      class="unicode strikethrough"
                      v-show="
                        d.price_edit &&
                        d.item.type == 'product' &&
                        d.original_price > d.price
                      "
                    >
                      {{ d.original_price | thousandSeparator }}
                    </span>
                    <span class="unicode pointer">
                      <strong>{{
                        (d.qty_real * d.price) | thousandSeparator
                      }}</strong>
                    </span>
                    <br />
                    <span class="subtotal-detail"
                      >{{ d.qty_real }} x
                      {{ d.price | thousandSeparator }}</span
                    >
                  </td>
                  <td>
                    <button
                      class="btn btn-danger btn-action"
                      @click="removeItem(k, d)"
                    >
                      <i class="cil-x"></i>
                    </button>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      class="mouse-pointer"
                      style="width: 100%"
                      v-model="d.include_delivery_letter"
                      @click="setDeliveryLetter(d)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="4">
        <c-card>
          <c-card-body style="overflow: auto">
            <div class="form-group">
              <span class="rp">Rp.</span>
              <span class="total">{{ header.total | thousandSeparator }}</span>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-4">Metode</label>
              <div class="col-md-8">
                <select-x
                  url="/api/v1/payment-method"
                  :size="10"
                  placeholder="pilih metode pembayaran"
                  v-model="header.method"
                  @input="changeMethod"
                  v-bind:class="{ 'has-error': errors.method }"
                />
              </div>
            </div>
            <div v-show="header && header.method && header.method.type_id == 1">
              <div class="form-group form-row">
                <label class="col-form-label col-sm-4">Bayar</label>
                <!-- <div class="col-md-8" v-if="trs.id">
                  <span class="form-control right">{{trs.cash | thousandSeparator}}</span>
                </div> -->
                <div class="col-md-8">
                  <button-edit-input-2
                    :rounded="true"
                    :bordered="true"
                    @input="changeAmount"
                    :value="header.amount"
                    v-bind:class="{ 'has-error': errors.amount }"
                  />
                </div>
              </div>
              <div class="form-group form-row">
                <label class="col-form-label col-sm-4">Kembalian</label>
                <div class="col-md-8">
                  <div class="col-md-12 bordered rounded right">
                    <span
                      class="right"
                      style="font-size: 22px; font-weight: bold"
                      >{{ header.kembalian | thousandSeparator }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-4">Via</label>
              <div class="col-md-8">
                <select-x
                  url="/api/v1/sale-channels"
                  :size="10"
                  placeholder="Pilih sumber pembelian"
                  v-model="header.channel"
                  @input="changeChannel"
                  v-bind:class="{ 'has-error': errors.channel_id }"
                />
              </div>
            </div>
            <div class="form-group">
              <label>Note</label>
              <textarea
                id
                cols="30"
                rows="3"
                v-model="header.note"
                class="form-control"
                placeholder="Add note"
              />
            </div>
            <div class="form-group" v-if="header.status == 2">
              <label>
                Alasan diubah *)&nbsp;
                <span v-if="errors.edit_reason" class="error">{{
                  errors.edit_reason[0].replace("edit reason", "reason")
                }}</span>
              </label>
              <textarea
                class="form-control"
                cols="30"
                rows="3"
                v-model="header.edit_reason"
                placeholder="Tambahkan alasan perubahan"
                minlength="20"
                v-bind:class="{ 'has-error': errors.edit_reason }"
              />
            </div>
            <div class="form-group">
              <label>Kurir</label>
              <input
                type="text"
                class="form-control"
                v-model="header.courier"
              />
            </div>
            <span>
              <strong>NB:</strong> Jika cash kurang dari total maka akan masuk
              ke daftar piutang.
            </span>
          </c-card-body>
          <c-card-footer>
            <sur-button
              :object="header"
              @onSave="save"
              @onUpdate="update"
              @onReset="reset"
            />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <modal
      :data="custModal"
      @close="custModal.show = false"
      @submit="saveCustomer"
      v-show="custModal.show"
      col="6"
    >
      <add-customer :data="custModal.data" :errors="custModal.errors" />
    </modal>
    <CModal
      title="Delete Confirmation"
      size="sm"
      color="danger"
      :show.sync="removeConfirm"
    >
      Yakin Akan menghapus data
      <br />"
      <span v-if="itemRemove && itemRemove.item">{{
        itemRemove.item.name
      }}</span
      >" ?
      <template #footer>
        <CButton @click="removeConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
    <CModal
      title="Print Confirmation"
      size="sm"
      color="info"
      :show.sync="printInvoice"
    >
      Cetak nota ?
      <template #footer>
        <CButton @click="printInvoice = false" color="danger">Tidak</CButton>
        <CButton @click="runInvoice" color="success">Ya</CButton>
      </template>
    </CModal>
    <CModal title="Search product" color="success" :show.sync="searchBox.show">
      <search-box @onSelect="onSelect" :object="searchBox" />
    </CModal>
  </div>
</template>
<style>
.customer-modal > div > div > div > div {
  padding: 0;
}
</style>
<script>
import ButtonEditInput2 from "../../components/ButtonEditInput2";
import SelectX from "../../components/SelectX";
import Modal from "../../components/Modal";
import SURButton from "../../components/SURButton";
import SearchBox from "./components/SearchBox";
import AddCustomer from "../customer/components/AddCustomer";
import Header from "../../lib/cashier/header"
import { showErrorMessage } from "../../lib/helpers"
import Detail, { setItemPrice } from '../../lib/cashier/detail';
import { HTTPAUTH } from '../../lib/httplib';
import ProductSelector from '../../components/ProductSelector.vue';
import Loader from '../../components/Loader.vue'
export default {
  name: "ChasierIndex",
  components: {
    SelectX,
    "sur-button": SURButton,
    SearchBox,
    ButtonEditInput2,
    Modal,
    AddCustomer,
    ProductSelector,
    Loader,
  },
  data () {
    return {
      loading: false,
      header: new Header(),
      errors: [],
      item: null,
      barcode: '',
      custModal: {
        errors: {},
        show: false,
        title: 'Add Customer',
        data: {
          customer_id: ''
        }
      },
      searchBox: {
        show: false
      },
      printInvoice: false,
      removeConfirm: false,
      itemRemove: null
    };
  },
  created () {
    /** get from cache */
    this.header = this.header.get()

    const query = this.$route.query
    if (query && query.id) {
      this.loading = true
      HTTPAUTH.get(`/api/v1/sale/${query.id}`).then(res => {
        this.header = this.header.populate(res.data.data)
        this.loading = false
      }).catch(eres => {
        console.log(eres)
        this.loading = false
      })
    }
    if (query && query.cid) {
      this.header.getCustomer(query.cid)
    }
    if (query && query.mt) {
      this.header.getPaymentMethod(query.mt)
    }
    if (query && query.ch) {
      this.header.getChannel(query.ch)
    }
    this.header.toast = this.$toasted
  },
  watch: {

  },
  methods: {
    upadteQuery (query) {
      this.$router.push({ query: query }).catch(() => { })
    },
    changeMethod (m) {
      const c = this.header.customer
      const ch = this.header.channel
      var query = {}
      query.cid = 0
      query.ch = 0
      if (c) {
        query.cid = c.id
      }
      if (ch) {
        query.ch = ch.id
      }
      if (!m) {
        this.header.getPaymentMethod(0)
        query.mt = 0
        this.upadteQuery(query)
        return
      }
      query.mt = m.type_id
      this.header.getPaymentMethod(m.id)
      this.header.recalculatePrice()
      this.upadteQuery(query)
    },
    changeCustomer (c) {
      const m = this.header.method
      const ch = this.header.channel
      var query = {}
      query.mt = 0
      query.ch = 0
      if (m) {
        query.mt = m.type_id
      }
      if (ch) {
        query.ch = ch.id
      }
      if (!c) {
        this.header.generateNumbers(0)
        query.cid = 0
        this.upadteQuery(query)
        return
      }
      query.cid = c.id
      this.header.getCustomer(c.id)
      this.header.generateNumbers(c.id)
      this.header.recalculatePrice()
      this.upadteQuery(query)
    },
    changeChannel (ch) {
      const c = this.header.customer
      const mt = this.header.method
      var query = {}
      query.mt = 0
      query.cid = 0
      query.ch = 0
      if (mt) {
        query.mt = mt.type_id
      }
      if (c) {
        query.cid = c.id
      }
      if (!ch) {
        this.header.getChannel(0)
        query.ch = 0
        this.upadteQuery(query)
        return
      }
      query.ch = ch.id
      this.header.getChannel(ch.id)
      this.upadteQuery(query)
    },
    searchItem (e) {
      if (e.keyCode === 13) {
        HTTPAUTH.get("/api/v1/search/product/barcode/" + this.barcode)
          .then(res => {
            this.item = res.data.data;
            this.addItem();
            this.barcode = "";
          })
          .catch(eres => {
            showErrorMessage(eres)
            // this.$toasted.error(eres.response.data.user_message).goAway(2000);
            this.barcode = "";
          });
      }
    },
    changePrice (val) {
      this.item.price_edit = true
      this.item.price = parseInt(val)
    },
    addItem () {
      const detail = new Detail(this.item, false, 1, false)
      detail.setPrice(this.header.customer, this.header.method)
      this.header.addDetail(detail)
      /** reset item original price */
      this.$store.dispatch('product_get_active', '')
      this.item = null
      this.header.save()
    },
    saveCustomer () {
      this.$store.dispatch('create', this.custModal.data).then(res => {
        this.header.customer = res
        this.custModal.show = false;
        this.custModal.data = {
          customer_id: ''
        };
      }).catch(eres => {
        this.custModal.errors = showErrorMessage(eres)
      })
    },
    removeItem (index, removeItem) {
      this.itemIndex = index;
      this.removeConfirm = true;
      this.itemRemove = removeItem;
    },
    runDelete () {
      const item = this.itemRemove.item
      this.header.details.splice(this.itemIndex, 1);
      this.header.calculateTotal();
      this.header.save();
      this.$toasted.show(`Item "${item.name}" telah dihapus`).goAway(1000);
      this.removeConfirm = false;
    },
    setDeliveryLetter (item) {
      item.include_delivery_letter = true;
      this.header.save()
    },
    save () {
      if (this.header && this.header.method && this.header.method.type_id == 1
        && this.header.amount <= 0) {
        const cof = confirm('Cash dengan pembayaran Rp.0 ? apakah ingin dilanjutkan ?')
        if (!cof) {
          return
        }
      }
      this.header.setChannel();
      HTTPAUTH.post("/api/v1/sale", this.header)
        .then(res => {
          this.printInvoice = true;
          this.printSelect = res.data.data.id;
          this.header = this.header.reset()
          this.upadteQuery();
          this.$store.dispatch('product_get_active', '')
        })
        .catch(eres => {
          const data = eres.response.data;
          if (data && data.user_message) {
            this.$toasted.error(data.user_message).goAway(3000);
            return;
          }
          this.$toasted.error(data.message).goAway(3000);
          this.errors = data.errors;
        });
    },
    runInvoice () {
      window.open("#/print/kasir/faktur/" + this.printSelect, "_blank");
      this.printInvoice = false;
    },
    changeAmount (amount) {
      this.header.amount = amount;
      this.header.kembalian = amount - this.header.total;
      this.header.save()
    },
    changeProduct (p) {
      if (!p) {
        return
      }
      this.item = setItemPrice(p, this.header.customer, this.header.method)
    },
    onSelect (p) {
      this.changeProduct(p)
      this.searchBox.show = false
    },
    update () {
      if (this.header && this.header.method && this.header.method.type_id == 1
        && this.header.amount <= 0) {
        const cof = confirm('Cash dengan pembayaran Rp.0 ? apakah ingin dilanjutkan ?')
        if (!cof) {
          return
        }
      }
      this.header.setChannel();
      HTTPAUTH.put(`/api/v1/sale/${this.header.id}/edit`, this.header)
        .then(res => {
          this.printInvoice = true;
          this.printSelect = res.data.data.id;
          this.header = this.header.reset()
          this.$store.dispatch('product_get_active', '')
          this.$router.push({ path: '/kasir' })
        })
        .catch(eres => {
          const data = eres.response.data;
          this.$toasted.error(data.message).goAway(3000);
          this.errors = data.errors;
        });
    },
    reset () {
      this.upadteQuery();
      this.header = this.header.reset()
    },
  },
  filters: {
    formatDate (d) {
      return moment(d).format("DD MMM YYYY");
    }
  }
};
</script>